import { render, staticRenderFns } from "./StaffAttendanceCountDashboard.vue?vue&type=template&id=0c25d65e&scoped=true&"
import script from "./StaffAttendanceCountDashboard.vue?vue&type=script&lang=js&"
export * from "./StaffAttendanceCountDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c25d65e",
  null
  
)

export default component.exports